import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MeldingBevestigingForm from "./MeldingBevestigingForm";
import MeldingenForm from "./MeldingenForm";
import AutoBindComponent from "../common/AutoBindComponent";
import Section from "../common/Section";
import redirector from "../../util/redirector";
import MeldingenPageHelper from "./MeldingenPageHelper";
import * as FilesHelperUtil from "../common/FilesHelperUtil";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import { throwException } from "../../actions/exceptionActions";

class MeldingenPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            meldingenModel: {
                id: null,
                voornaam: "",
                achternaam: "",
                organisatie: "",
                telefoon: "",
                gsm: "",
                email: "",
                bevestigEmail: "",
                datum: "",
                omschrijving: "",
				meldingInNaamVanAnderePersoon: false,
				adres: {
					id: null,
					adresObjectId: null,
					displayName: "",
					gemeenteId: "",
					gemeente: "",
					postCode: "",
					straatId: 0,
					straatNaam: "",
					huisNummer: "",
					busNummer: "",
					latitude: null,
					longitude: null
				}
			},
            meldingenBijlage: [],
            hasUnsavedDocumentChanges: false,
            fileSessionId: null,
            errors: [],
            meldingSent: false,
			sendButtonDisabled: true
        };

        this.filesHelper = null;
        this.pageHelper = new MeldingenPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    }

    handleOnChange = (event) => this.pageHelper.change(event);
	handleCheckboxChange = (event) => this.pageHelper.changeCheckbox(event);
    handleOnSave = () => this.pageHelper.save();
    handleOnDropFile = (propertyName, files) => this.pageHelper.addBijlage(FilesHelperUtil.onDropFiles(this.state[propertyName], propertyName, files));
    handleOnRemoveFile = (propertyName, fileName) => this.pageHelper.removeBijlage(FilesHelperUtil.onRemoveFile(this.state[propertyName], propertyName, fileName));
	handleOnAdresSave = (adres) => this.pageHelper.saveAdres(adres);
	handleOnCaptchaVerified = (verified) => this.pageHelper.onCaptchaVerified(verified);

    render() {
        if (!!this.filesHelper === false) return null;

        return (
            <Section>
                {this.state.meldingSent ?
                    <MeldingBevestigingForm /> :
                    <MeldingenForm
						meldingenModel={this.state.meldingenModel}
						onAdresSave={this.handleOnAdresSave}
                        onChange={this.handleOnChange}
						onChangeCheckbox={this.handleCheckboxChange}
                        onSave={this.handleOnSave}
                        onDropFiles={this.handleOnDropFile}
                        onRemoveFile={this.handleOnRemoveFile}
						onCaptchaVerified={this.handleOnCaptchaVerified}
                        fileDownloadUrl={this.filesHelper.getFileDownloadUrl()}
                        filesComponent={this.state.meldingenBijlage}
						sendButtonDisabled={this.state.sendButtonDisabled}
                        errors={this.state.errors}
                    />
                }
            </Section>
        );
    }
}

MeldingenPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
		throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MeldingenPage);
